import { Component } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldBaseComponent } from '@shared/components/forms/components/field-base';

@Component({
  selector: 'lib-form-button-group',
  templateUrl: 'form-button-group.component.html',
  imports: [FormsModule, ReactiveFormsModule],
})
export class FormButtonGroupComponent extends FieldBaseComponent {
  public submit($event: Event) {
    $event.preventDefault();
    if (this.formGroup && this.config?.onSubmit) {
      this.config.onSubmit(this.formGroup);
    }
    this.fc.validate();
  }
}
